/* eslint-disable prettier/prettier */
/* prettier-ignore-file */

import { apiService } from './api.service';

export interface Timezone {
	label: string;
	value: string;
}

export const timezoneService = {
	async getAllTimezones(): Promise<Timezone[]> {
		try {
			// 👇 T is Timezone[], not TimezoneResponse
			const response = await apiService.get<Timezone[]>(
				'/timezone/timezones'
			);

			if (!response.success) {
				throw new Error(response.message);
			}

			return response.data;
		} catch (error: any) {
			console.error('Timezone fetch error:', error);
			throw new Error(error.message || 'Failed to fetch timezones');
		}
	},
};
